import { connect } from "react-redux";

import { showToast } from "../../actions/toasts";

import ResetPasswordFormContainer from "./ResetPasswordFormContainer";

const mapDispatchToProps = dispatch => {
    return {
        showToast: options => dispatch(showToast(options))
    };
};

const mapStateToProps = state => {
    return {
        user: state.user.profile
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ResetPasswordFormContainer);
